import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import toast from "react-hot-toast";
import CancelIcon from "@mui/icons-material/Cancel";
import PDFUploader from "./PDFUploader";
import FileList from "./FileList";
import { getFileOfUserAPI } from "../../../../services/rest/files/filesProvider";
import { useSelector } from "react-redux";
import { handleError } from "../../../../utils/handleError";
import { handleConvertMothtoString } from "../../../../components/Dashboard/ProfileUser/formatData";

const ModalViewFiles = ({ open, setOpen, setLoading, selectedUser }) => {
  const { _id, firstName } = useSelector((state) => state.userReducer);
  const [selectedChip, settSelectedChip] = useState("files");
  const [isDelete, setIsDelete] = useState(false);
  const [selectedFile, setSelectedFile] = useState({});
  const [listFiles, setListFiles] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  // console.log("Paciente seleccionado", selectedUser);

  const handleClose = useCallback(() => {
    setIsDelete(false);
    setListFiles([]);
    setSelectedDate(new Date());
    setOpen(false);
  }, [setOpen]);

  const getFilePatient = useCallback(
    async (date) => {
      try {
        setLoading(true);

        const fecha = new Date(date);

        const dateData = {
          month: fecha.getMonth() + 1, // getMonth() devuelve 0-11, por eso sumamos 1
          year: fecha.getFullYear(),
        };
        // console.log("Buscando archivos para la fecha:", dateData);

        if (date) {
          // Se hace la peticion del archivo con la fecha seleccionada
          const responseFile = await getFileOfUserAPI({
            id_patient: selectedUser?._id,
            id_provider: _id,
            dateData,
          });
          const formattedFiles = responseFile.map((url, index) => {
            const fileName = `Reporte_${firstName}_${handleConvertMothtoString(fecha.getMonth() + 1) ?? ""}_${fecha.getFullYear() ?? ""}_${index + 1}`; // Obtiene "reporte1747757042935.pdf"
            return {
              url: url,
              name: fileName.replace(".pdf", ""), // Remueve la extensión .pdf
            };
          });

          // console.log("Archivo recibido", formattedFiles);

          setListFiles(formattedFiles);
        }

        setLoading(false);
      } catch (error) {
        setLoading(false);
        // handleClose();
        const { message } = handleError(error);
        // console.log("Error en modal files", error);
        toast.error(`${message}`);
      }
    },
    [handleClose, setLoading, selectedUser]
  );

  useEffect(() => {
    if (open) {
      // Al abrir el modal, busca los archivos de la fecha actual
      getFilePatient(selectedDate);
    }
  }, [selectedUser, getFilePatient, open, selectedDate]);

  const onDelete = () => {
    try {
      setLoading(true);
      console.log("Archivo seleccionado para eliminar", selectedFile);
      handleClose();
      setLoading(false);
      toast.success(
        `Se elimino correctamente el archivo de ${selectedUser?.firstName ?? ""}`
      );
    } catch (error) {
      setLoading(false);
      toast.error(
        "No se pudo eliminar el archivo. \n Intentelo en otro momento."
      );
    }
  };

  return (
    <Dialog open={open} fullWidth maxWidth="md">
      <DialogTitle>
        <Typography sx={{ textAlign: "center" }}>
          Historial de archivos de {selectedUser?.firstName}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ padding: 5 }}>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            gap: 4,
            justifyContent: "center",
          }}
        >
          <Chip
            label="Archivos"
            style={
              selectedChip === "files"
                ? {
                    backgroundColor: "#e7ef7d",
                    color: "black",
                  }
                : {}
            }
            onClick={() => settSelectedChip("files")}
          />
          <Chip
            label="Subir Archivo"
            variant={"filled"}
            style={
              selectedChip === "newFile"
                ? {
                    backgroundColor: "#e7ef7d",
                    color: "black",
                  }
                : {}
            }
            onClick={() => settSelectedChip("newFile")}
          />
        </Box>
        {selectedChip === "files" ? (
          <Box>
            <FileList
              files={listFiles}
              setIsDelete={setIsDelete}
              setSelectedFile={setSelectedFile}
              selectedDate={selectedDate}
              setSelectedDate={(newDate) => {
                setSelectedDate(newDate);
                getFilePatient(newDate);
              }}
            />
          </Box>
        ) : (
          <Box>
            <PDFUploader
              setLoading={setLoading}
              selectedUser={selectedUser}
              handleClose={handleClose}
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Box sx={{ display: "flex", gap: 2 }}>
          {isDelete && (
            <Button
              variant="outlined"
              sx={{ borderColor: "white", color: "white" }}
              onClick={onDelete}
              startIcon={<CancelIcon />}
            >
              Eliminar Archivo
            </Button>
          )}
          <Button
            variant="contained"
            onClick={handleClose}
            sx={{ backgroundColor: "#e7ef7d" }}
            startIcon={<CancelIcon />}
          >
            Cerrar
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default ModalViewFiles;
